<template>
  <div class="profile-container container">
    <div class="profile-portrait">
      <div class="profile-portrait-container">
      <figure>
        <img src="../../assets/images/OlamideJogunola.jpg" alt="Olamide Jogunola" >
          </figure>
         <div class="finger-print"><img src="@/assets/images/fingerprints/fingerprint-six.svg" alt=""></div>
      </div>
    </div>
    <div class="profile-statement">

      <h2>Olamide Jogunola</h2>

      <p class="job-title">Lecturer</p>

        <p class="profile-statement-interviewer">Tell us a little bit about yourself</p>

        <p>I am a Lecturer in Cyber Security/Smart grid at the Department of Computing and Mathematics.</p>

        <p class="profile-statement-interviewer">What inspires you within your role?</p>

        <p>My current role involves teaching and research. In terms of teaching, I love being able to support students and faculty colleagues and hopefully be a positive, small part of a student’s career journey. In terms of research, I enjoy the never ending cycle of finding solutions to a problem, getting published. I also find it rewarding to have the opportunity to travel across the world presenting research results at conferences, project meetings, and as a Keynote speaker. One more thing that inspires me within my role is being in a supportive team who is open, enthusiastic, and willing to share ideas, supporting colleagues and students</p>

        <p class="profile-statement-interviewer">What is something that you love about your culture or heritage? </p>

        <p>I love the sense of community, the art of sharing, the food, music, and parties (weddings in particular).</p>

        <p class="profile-statement-interviewer">What does it look like to bring your whole self to your work? </p>

        <p>To bring my whole self to work means to be a positive, friendly, and enthusiastic faculty member who is open to sharing and celebrating my uniqueness, life experiences and individuality with all staff and students. In doing so, hopefully I can encourage others to do the same and set a good example to follow.</p>
          
        <p class="profile-statement-interviewer">How do you think MMU can best celebrate their Black, Asian, and Ethnic Minority staff and students?</p>

        <p>By celebrating every win and highlighting every major contribution.</p>

        <p class="profile-statement-interviewer">What are you most proud of?</p>

        <p>My work ethics and my family.</p>

    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

  .profile-container {
  flex-direction: row-reverse;
  }

  .profile-portrait-container {
    justify-content: flex-end;

    & figure {
      text-align: right;
    }
  }

  // .profile-statement {
  //   padding-right: 5rem;
  //   // padding-left: 5rem;
  // }

</style>